import { useQuery } from '@tanstack/react-query';
import { allocationQueries } from '../queries';

export function useProjects(search: string, contractId?: number) {
  return useQuery(allocationQueries.projects(search, contractId));
}
